import { render, staticRenderFns } from "./index_new.vue?vue&type=template&id=081cf6ae&scoped=true&"
import script from "./index_new.vue?vue&type=script&lang=js&"
export * from "./index_new.vue?vue&type=script&lang=js&"
import style0 from "./index_new.vue?vue&type=style&index=0&id=081cf6ae&prod&lang=less&"
import style1 from "./index_new.vue?vue&type=style&index=1&id=081cf6ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081cf6ae",
  null
  
)

export default component.exports